import { takeLeading, put, select } from 'redux-saga/effects'
import {
  UPDATE_TEMPLATE_FRAGMENTS,
  postUpdateFragments,
} from 'actions/powerTakeOff'
import { getVehicleRouteMatch } from 'selectors/router'
import { selectTemplateFragmentsFromDiff } from 'selectors/powerTakeOff'

export function* watchUpdateTemplateFragments() {
  yield takeLeading(UPDATE_TEMPLATE_FRAGMENTS, submitTemplateFragments)
}

function* submitTemplateFragments(action) {
  const { notes, templateId, callback } = action
  const fragments = yield select((state) =>
    selectTemplateFragmentsFromDiff(state, { templateId })
  )

  const {
    params: { id: serialNumber },
  } = yield select(getVehicleRouteMatch)

  yield put(postUpdateFragments(serialNumber, fragments, notes, callback))
}
